// =====================================================
// Troc div masonry logic
// =====================================================
jQuery(document).ready(($) => {
  // remove hardcoded height from selected images
  const $trocImages = $(
    ".main-trocs article img, #troc-du-moment .image-wrapper img"
  );
  $trocImages.removeAttr("height");

  const $trocsContainer = $("#trocs");
  let initialCategory = "first-page-troc";
  if ($("body").hasClass("category")) {
    initialCategory = $("#categoryFilter").text();
  }
  function generateTrocs(filter, destroy) {
    $(".troc").show();
    $(`.troc:not(.${filter})`).hide();

    // if not first render, destroy old first
    if (destroy) {
      $trocsContainer.masonry("destroy");
    }

    $trocsContainer.masonry({
      itemSelector: `.${filter}`,
      columnWidth: ".troc",
      gutter: 10,
    });

    $trocsContainer.imagesLoaded().progress(() => {
      $trocsContainer.masonry("layout");
    });

    // $(window).resize(() => {
    //   $trocsContainer.masonry("layout");
    // });
  }

  // create filtered masonry on menu clicks
  const $menuItems = $(".menu a");
  $menuItems.on("click", (e) => {
    e.preventDefault();
    $menuItems.removeClass("active");
    $(e.target).addClass("active");
    const filteredTxt = replaceCharacters($(e.target).text());
    const editionsTxt = ["die-edition", "l-edition"];
    if (editionsTxt.indexOf(filteredTxt) > -1) {
      generateTrocs("troc", true);
    } else {
      generateTrocs(`${filteredTxt}`, true);
    }
  });
  // create masonry on load (if not aktuell/de-cric/des-amis directly)
  // generateTrocs("troc", false);
  var editionPaths = ["/fr/troc/", "/fr/troc", "/de/troc-2/", "/de/troc-2"];
  var aktuellPaths = [
    "/fr/category/troc/actualites/",
    "/fr/category/troc/actualites",
    "/de/category/tauschen/aktuell/",
    "/de/category/tauschen/aktuell",
  ];
  var cricPaths = [
    "/fr/category/troc/de-cric/",
    "/fr/category/troc/de-cric",
    "/de/category/tauschen/von-cric/",
    "/de/category/tauschen/von-cric",
  ];
  var friendPaths = [
    "/fr/category/troc/de-nos-amis/",
    "/fr/category/troc/de-nos-amis",
    "/de/category/tauschen/von-freunden/",
    "/de/category/tauschen/von-freunden",
  ];
  var editionCat = editionPaths.indexOf(window.location.pathname) > -1;
  var aktuellCat = aktuellPaths.indexOf(window.location.pathname) > -1;
  var cricCat = cricPaths.indexOf(window.location.pathname) > -1;
  var friendCat = friendPaths.indexOf(window.location.pathname) > -1;
  if (editionCat) {
    $(".menu li a")
      .first()
      .click();
  } else if (aktuellCat) {
    $(".menu li a")
      .eq(1)
      .click();
  } else if (cricCat) {
    $(".menu li a")
      .eq(2)
      .click();
  } else if (friendCat) {
    $(".menu li a")
      .eq(3)
      .click();
  }

  function replaceCharacters(input) {
    input = input.toLowerCase();
    input = input.replace(/\s+/g, "-");
    input = input.replace(/'/g, "-");
    input = input.replace(/’/g, "-");
    input = input.replace(/[éèê]/g, "e");
    input = input.replace(/à/g, "a");
    input = input.replace(/ä/g, "ae");
    input = input.replace(/ö/g, "oe");
    input = input.replace(/ü/g, "ue");
    input = input.replace(/ß/g, "ss");
    input = input.replace(/ /g, "-");
    input = input.replace(/\./g, "");
    input = input.replace(/,/g, "");
    input = input.replace(/\(/g, "");
    input = input.replace(/\)/g, "");
    return input;
  }
});
// =====================================================
// On small screens (md), make Troc link top right trigger click on Troc filter
// =====================================================
jQuery(document).ready(($) => {
  function screenSize(x) {
    if (x.matches) {
      $("body").addClass("size-md-and-smaller");
    } else {
      $("body").removeClass("size-md-and-smaller");
    }
  }
  const x = window.matchMedia("(max-width: 1024px)");
  screenSize(x);
  x.addListener(screenSize);
});
jQuery(document).ready(($) => {
  if ($("body").hasClass("size-md-and-smaller")) {
    // menu element different functionality
    $("#troc-page-link").on("click", function(e) {
      e.preventDefault();
      $("ul.menu > li:first-of-type > a").trigger("click");
    });
    // Troc du moment on small screens: scroll to it.
    $(".scrollToTrocDuMoment").on("click", function(e) {
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop: $("#yellow-wrapper").offset().top,
        },
        "slow"
      );
    });
  }
});
